export default __webpack_public_path__ + "static/media/notification-status-grey.145945e2.svg";